/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

function SEO({ description, lang, meta, title, image }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            defaultDescription: description
            siteUrl: url
            siteUrlInsecure: urlInsecure
            author
            defaultImage: image
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.defaultDescription;
  const imgUrl = `${site.siteMetadata.siteUrl}${image || site.siteMetadata.defaultImage}`;
  const imgUrlInsecure = `${site.siteMetadata.siteUrlInsecure}${image || site.siteMetadata.defaultImage}`;

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      image={imgUrl}
      titleTemplate={`%s | ${site.siteMetadata.title}`}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          name: `image`,
          content: imgUrl,
        },
        {
          property: `og:image`,
          content: imgUrlInsecure,
        },
        {
          property: `og:image:secure_url`,
          content: imgUrl,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:url`,
          content: site.siteMetadata.siteUrl,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          property: `twitter:image`,
          content: imgUrlInsecure,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata.author,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ].concat(meta)}
    />
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
  image: PropTypes.string
}

export default SEO
